import Text from '../../../../atoms/Text';
import Image from '../../../../atoms/Image';
import { ReactComponent as SkeletonNormal } from '../../images/skeleton_normal.svg';
import big_arrow_left from '../../../../assets/images/arrow_left.svg';

interface INotSupportedProps {
  scroll: boolean;
  account: boolean;
  toMarket(): void;
}

const NotSupported = ({ scroll, account, toMarket }: INotSupportedProps) => {
  return (
    <>
      <div
        className='simple_tab_selector simple_tab_selector--clickable'
        onClick={toMarket}
      >
        <Image size='s' src={big_arrow_left} />
        <Text size={12} className='simple_tab_selector__tab'>
          Swap
        </Text>
      </div>
      {scroll ? null : (
        <div className='skeleton'>
          <SkeletonNormal />
        </div>
      )}
      <div className='placeholder__text'>
        <Text size={12}>
          {account
            ? 'This network is not supported yet'
            : 'Connect wallet to use this feature'}
        </Text>
      </div>
    </>
  );
};

export default NotSupported;
